<!-- this div will be used to anchor all page content -->
<!-- in print mode it will go to the lowest of the page-->
<div class="toc-container">
    <div class="above-title-margin"></div>
    <h1 class="title" stylePreference [textColor]="titleColor">
        {{ (tableOfContentTitleKey | i18nextWithLocale : activeLocale) || tableOfContentTitleKey }}
    </h1>
    <div class="above-toc-margin"></div>
    <div class="toc-container">
        <div class="toc-content-items" *ngFor="let item of contentItems; let index = index">
            <div class="{{ item.id }}">
                <div class="flex-row line">
                    <span class="flex-grow-1" stylePreference [textColor]="textColor">
                        <span *ngIf="item.isLocalized"> {{ item.labelOrLabelKey | i18next }} </span>
                        <span *ngIf="!item.isLocalized">{{ item.labelOrLabelKey }}</span>
                    </span>
                    <span class="right-align page-number-placeholder" stylePreference [textColor]="textColor">
                        {{ item.pageNumberPlaceHolder }}
                    </span>
                </div>
                <div *ngIf="item.subItems" stylePreference [textColor]="textColor" class="sub-item">
                    <ul>
                        <li class="" *ngFor="let subItem of item.subItems">
                            <div class="line line-smaller-4px">
                                <span class="line line-smaller-4px number" *ngIf="!subItem.disableNumbering">{{
                                    subItem.title.number }}</span>
                                {{ subItem.title.title }}
                            </div>
                            <ul>
                                <li *ngFor="let value of subItem.components">
                                    <div class="line-smaller-6px line">
                                        <span class="line line-smaller-6px number">
                                        {{ value.number }}
                                        </span>
                                        {{ value.title }}
                                    </div>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="above-separator-margin"></div>
                <div class="horizontal-separator"></div>
                <div class="under-separator-margin"></div>
            </div>
        </div>
    </div>
</div>